import React, { useState } from 'react';
import { Modal, Input, Button } from 'antd';
import { X } from 'lucide-react';
import styles from './RejectConfirmModal.module.css';

const { TextArea } = Input;

export interface RejectConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<void>;
}

export const RejectConfirmModal: React.FC<RejectConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!reason.trim()) {
      return;
    }
    setLoading(true);
    try {
      await onConfirm(reason);
      setReason('');
      onClose();
    } catch (error) {
      console.error('Reject failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setReason('');
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      footer={null}
      closeIcon={<X size={20} />}
      className={styles.modal}
      width={500}
      destroyOnHidden
    >
      <div className={styles.modalContent}>
        <h2 className={styles.modalTitle}>Xác nhận từ chối chỉnh sửa?</h2>
        
        <p className={styles.modalDescription}>
          Sau khi xác nhận, yêu cầu chỉnh sửa thông tin của nhân viên sẽ bị từ chối và không thể hoàn tác. Bạn có chắc chắn muốn tiếp tục không?
        </p>

        <div className={styles.formItem}>
          <label className={styles.label}>Lý do từ chối</label>
          <TextArea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Nhập lý do từ chối"
            rows={4}
            className={styles.textArea}
          />
        </div>

        <div className={styles.modalFooter}>
          <Button
            type="default"
            onClick={handleCancel}
            className={styles.cancelButton}
          >
            Hủy
          </Button>
          <Button
            type="primary"
            onClick={handleConfirm}
            loading={loading}
            disabled={!reason.trim()}
            className={styles.confirmButton}
          >
            Từ chối
          </Button>
        </div>
      </div>
    </Modal>
  );
};
